var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"step-puzzle__list"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,class:{
        selected: step.id == _vm.stepUserIs,
        'left-arrow': index > 0,
        'step-ok': step.id < _vm.stepUserIs,
      },on:{"click":function($event){return _vm.$emit('click', { index: index, step: step })}}},[_c('p',{staticClass:"step-puzzle__number"},[_c('span',[_vm._v(_vm._s(step.number))]),_vm._v(" "),_c('span',{staticClass:"step-puzzle__text"},[_vm._v(_vm._s(step.text))])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00051a21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JNSStepPuzzle.vue
// module id = mJtJ
// module chunks = 0